<div class="tw-p-4 tw-mx-4 tw-mb-3 tw-border tw-rounded-xl tw-bg-white tw-flex tw-gap-5 tw-shadow-z1" (click)="bannerClick()">
  <div class="tw-w-full tw-flex tw-flex-col tw-items-start">
    <p class="tw-font-lexend tw-text-500 tw-font-bold tw-mb-2" i18n="@@stepByStepGuide">Step-by-Step Guide</p>
    <p class="tw-font-body tw-text-300 tw-text-gray-500 tw-leading-5" i18n="@@knowWhenHowToUseEachProductInKit">Know when and how to use each product in your kit</p>
  </div>
  <div class="tw-w-full tw-max-w-[80px] tw-flex tw-justify-center tw-items-center tw-rounded-lg" [ngClass]="regimenBackgroundColor">
    <img [src]="regimenKitImage" class="tw-w-full">
  </div>
</div>
